/* eslint-disable default-case */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {
   Input, Table, Space, Tooltip, Button, Popconfirm,
   Tag, Modal, Spin, Tabs, Skeleton, Empty
} from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import {
   SearchOutlined, CloudUploadOutlined, ProfileOutlined, DeleteOutlined, BookOutlined,
   ClockCircleOutlined, CheckCircleOutlined, RollbackOutlined
} from '@ant-design/icons';
// import SideCalendar from '../../components/side-calendar/SideCalendar';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import Details_Submit from './Components/Details_Submit';
import ProcessingModal from '../../components/processing/ProcessingModal';
import '../common/BraineeModule.css';
import { decorateMicrocredentialRecord, isMicrocredentialHomework, recordMatchesMicrocredentialCourse } from './microcredentialUtils';
import { isPlagiarismCheckerEnabled } from './plagiarismUtils';

// const { Text } = Typography;
// const { Option } = Select;

export function StudentHomeworks(props) {
   // const navigate = useNavigate();

   const search = window.location.search;
   const query = new URLSearchParams(search);
   const subject = query.get('s');
   const subjectname = query.get('sn');

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   const [homeworkID, setHomeworkID] = useState("");
   const [homeworkList, setHomeworkList] = useState([]);
   const [homeworkListLoading, setHomeworkListLoading] = useState(false);
   const [isCompactListView, setIsCompactListView] = useState(() => window.innerWidth <= 768);

   const [submitting, setSubmitting] = useState(false);

   const [detailsModalVisible, setDetailsModalVisible] = useState(false);
   const [canSubmit, setCanSubmit] = useState(true);
   const [returned, setReturned] = useState(false);
   const [remarks, setRemarks] = useState(null);
   const [plagiarismCheckerEnabled, setPlagiarismCheckerEnabled] = useState(false);

   const [processing, setProcessing] = useState(false);
   const submitFormRef = useRef(null);

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   const isMicrocredentials = props.isMicrocredentials || isMicrocredentialHomework(props.type);
   const workType = isMicrocredentials ? 'microcredential' : 'homework';
   const moduleLabel = isMicrocredentials ? 'Homeworks & Projects' : 'Homework';
   const rootLabel = isMicrocredentials ? 'Brainee Microcredentials' : 'Brainee LMS';
   const subjectsRoute = isMicrocredentials ? '/studentmicrocredentials/homeworks/subjects' : '/studenthomeworks/subjects';
   const heroKicker = isMicrocredentials ? 'Brainee Microcredentials' : 'Homework';

   useEffect(() => {
      Utils.verifyJwt();

      window.addEventListener('error', e => {
         if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            const resizeObserverErrDiv = document.getElementById(
               'webpack-dev-server-client-overlay-div'
            );
            const resizeObserverErr = document.getElementById(
               'webpack-dev-server-client-overlay'
            );
            if (resizeObserverErr) {
               resizeObserverErr.setAttribute('style', 'display: none');
            }
            if (resizeObserverErrDiv) {
               resizeObserverErrDiv.setAttribute('style', 'display: none');
            }
         }
      });

      // handleSearchHomeworks(user_id);
      refreshList("1");
   }, []);

   useEffect(() => {
      const handleResize = () => {
         setIsCompactListView(window.innerWidth <= 768);
      };

      window.addEventListener('resize', handleResize);
      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
               {/* <Button
                  type="link"
                  size="small"
                  onClick={() => {
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Filter
               </Button> */}
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const HomeworkListColumns = [
      {
         title: 'Title',
         key: 'title',
         sorter: (a, b) => { return a.title.localeCompare(b.title) },
         ...getColumnSearchProps('title'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tag
               style={{ fontSize: 12, cursor: 'default' }}
               color={object.returned ? "purple" : (object.submit_id === null && object.evaluation_id === null ? 'red' : (object.submit_id !== null && object.evaluation_id === null ? 'gold' : 'green'))}
            >
               <Tooltip placement="right" title={object.returned ? " (Returned)" : (object.evaluation_id !== null ? object.title + " (Completed)" : (object.submit_id !== null && object.evaluation_id === null ? object.title + " (For Evaluation)" : object.title))}>
                  <span style={{ cursor: "default" }}>{object.title}</span>
                  <p style={{ marginBottom: '0px', cursor: "default" }}>{object.homework_date}</p>
               </Tooltip>
            </Tag>
         ),
         width: '22%'
      },
      {
         title: 'Teacher',
         key: 'teacher',
         dataIndex: 'teacher',
         sorter: (a, b) => { return a.teacher.localeCompare(b.teacher) },
         width: '12%'
      },
      {
         title: isMicrocredentials ? 'Course / Topic' : 'Subject',
         key: 'subject',
         dataIndex: 'subject',
         sorter: (a, b) => { return (a.subject || '').localeCompare(b.subject || '') }, ...getColumnSearchProps('subject'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="right" title={object}>
               <span style={{ cursor: "default" }}>{object}</span>
            </Tooltip>
         ),
         width: '10%'
      },
      {
         title: 'Submission Date',
         key: 'submission_date',
         dataIndex: 'submission_date',
         sorter: (a, b) => { return a.submit_date.localeCompare(b.submit_date) },
         width: '10%'
      },
      {
         title: 'Evaluation Date',
         key: 'evaluation_date',
         dataIndex: 'evaluation_date',
         width: '10%'
      },
      {
         title: 'Score',
         key: 'score',
         hidden: user_role === 'Parent',
         sorter: (a, b) => a.score - b.score,
         render: payload => {
            return <>
               {
                  payload.max_score !== null
                     ?
                     <span>{payload.score === 0 ? '' : payload.score + "/" + payload.max_score}</span>
                     :
                     <span>{payload.score === 0 ? '' : payload.score}</span>
               }
            </>
         },
         width: '6%'
      },
      {
         title: 'Remarks',
         key: 'remarks',
         dataIndex: 'remarks',
         width: '20%'
      },
      {
         title: 'Status',
         width: '8%',
         render: object => {
            return <>
               <span>
                  {
                     object.returned ? "RETURNED" : (object.submit_id === null && object.evaluation_id === null ? '' : (object.submit_id !== null && object.evaluation_id === null ? 'FOR EVALUATION' : 'COMPLETED'))
                  }
               </span>
            </>
         }
      },
      {
         title: 'Action',
         key: 'action',
         hidden: user_role === 'Parent',
         render: payload => {
            return <>
               {user_role !== "Parent"
                  ?
                  <Space size="small">
                     <Tooltip placement="left" title='Show Homework Details'>
                        <ProfileOutlined color='#4abec7' style={{ cursor: 'pointer' }}
                           // onClick={() => handleShowHomeworkDetails(payload.id, ((payload.submit_id === null && !payload.expired) || payload.returned), payload.returned, payload.remarks)}
                           onClick={() => handleShowHomeworkDetails(payload.id, (payload.submit_id === null || payload.returned), payload.returned, payload.remarks, payload.plagiarism_checker)}
                        />
                     </Tooltip>
                     {payload.submit_id !== null && payload.evaluation_id === null &&
                        <Tooltip placement="left" title='Unsubmit Homework'>
                           <Popconfirm
                              title="Are you sure you want to unsubmit your homework?"
                              onConfirm={() => handleRemoveSubmission(payload.submit_id)}
                              okText="Yes"
                              cancelText="No"
                           >
                              <DeleteOutlined color='#4abec7' style={{ cursor: 'pointer' }} />
                           </Popconfirm>
                        </Tooltip>
                     }
                  </Space>
                  :
                  <></>
               }

            </>
         },
         width: '5%'
      },
   ].filter(item => !item.hidden);

   const handleSearchHomeworks = (submitted, returned) => {
      setHomeworkListLoading(true);

      var url = `${process.env.REACT_APP_API_HOMEWORK}/listperstudent?id=${user_id}&s=${subject}&su=${submitted}&type=${workType}`;

      if (isMicrocredentials)
         var url = `${process.env.REACT_APP_API_HOMEWORK}/listperstudent/microcredentials?id=${user_id}&s=${subject}&su=${submitted}&type=${workType}`;

      axios.get(url).then((response) => {
         console.log(response);

         if (response.data) {
            const data = response.data;

            //-- if returned, filter only returned
            if (returned !== undefined && returned !== null && returned === true) {
               const filtered = data.filter(item => item.returned === true).filter((record) => !isMicrocredentials || recordMatchesMicrocredentialCourse(record, subject));
               setHomeworkList(isMicrocredentials ? filtered.map((record) => decorateMicrocredentialRecord(record, { fallbackCourseName: subjectname })) : filtered);
            } else {
               const filtered = data.filter(item => item.returned !== true).filter((record) => !isMicrocredentials || recordMatchesMicrocredentialCourse(record, subject));
               setHomeworkList(isMicrocredentials ? filtered.map((record) => decorateMicrocredentialRecord(record, { fallbackCourseName: subjectname })) : filtered);
            }

            setHomeworkListLoading(false);
         }
      }, (error) => {
         setHomeworkListLoading(false);
         console.log(error.message);
      });
   }

   const handleRemoveSubmission = (id) => {
      setHomeworkListLoading(true);
      var url = `${process.env.REACT_APP_API_HOMEWORK}/unsubmithomework?id=${id}`;

      axios.post(url).then(response => {
         if (response.data) {
            setHomeworkListLoading(false);

            Modal.success({
               title: 'Homework',
               content: 'Homework unsubmitted.',
               centered: true,
            });

            handleSearchHomeworks();
         }
      }, (error) => {
         setHomeworkListLoading(false);
         Modal.error({
            title: 'Homework',
            content: error.response.data,
            centered: true,
         });
      });
   }

   const handleCancelSubmit = () => {
      setHomeworkID("");
      setPlagiarismCheckerEnabled(false);
      setDetailsModalVisible(false);
   }

   const handleShowHomeworkDetails = (id, can_submit, returned, remarks, plagiarismChecker) => {
      setRemarks(remarks);
      setReturned(returned);
      setCanSubmit(can_submit);
      setHomeworkID(id);
      setPlagiarismCheckerEnabled(isPlagiarismCheckerEnabled(plagiarismChecker));
      setDetailsModalVisible(true);
   }

   const handleCancelDetails = () => {
      setDetailsModalVisible(false);
   }

   const handleSaveSubmittedHomework = (data, fileForUpload) => {
      setSubmitting(true);

      if (fileForUpload.length > 0) {
         var formData = new FormData();

         fileForUpload.forEach(file => {
            formData.append('files', file);
         });

         var uploadedfiles = "";
         const uploadEndpoint = plagiarismCheckerEnabled ? 'uploadWithPlagiarism' : 'uploadMultiple';
         var url = `${process.env.REACT_APP_API_S3_UPLOAD}/${uploadEndpoint}?s3path=${process.env.REACT_APP_S3_HOMEWORKS_STUDENTS_PATH}`;
         axios.post(url, formData).then(response => {

            if (response.data) {
               uploadedfiles = response.data;

               data.document = uploadedfiles;

               var url = `${process.env.REACT_APP_API_HOMEWORK}/submithomework`;
               axios.post(url, data).then(response => {
                  setSubmitting(false);
                  setDetailsModalVisible(false);
                  if (response.data) {
                     Modal.success({
                        title: 'Homework',
                        content: 'Homework submitted.',
                        centered: true,
                        onOk: () => { setDetailsModalVisible(false) },
                     });

                     handleSearchHomeworks();
                  }
               }, (error) => {
                  setSubmitting(false);
                  Modal.error({
                     title: 'Homework',
                     content: error.response.data,
                     centered: true,
                     onOk: () => { setDetailsModalVisible(false) },
                  });
               });
            }
         }, (error) => {
            // console.log(error.message);
         });
      } else {
         var url = `${process.env.REACT_APP_API_HOMEWORK}/submithomework`;
         axios.post(url, data).then(response => {
            setSubmitting(false);
            if (response.data) {
               Modal.success({
                  title: 'Homework',
                  content: 'Homework submitted.',
                  centered: true,
                  onOk: () => { setDetailsModalVisible(false) },
               });

               handleSearchHomeworks();
            }
         }, (error) => {
            setSubmitting(false);
            Modal.error({
               title: 'Homework',
               content: error.response.data,
               centered: true,
               onOk: () => { setDetailsModalVisible(false) },
            });
         });
      }
   }

   const handleTabChange = (key) => {
      refreshList(key);
   }

   const refreshList = (tab) => {
      switch (tab) {
         case "1":
            handleSearchHomeworks(false, false);
            break;
         case "2":
            handleSearchHomeworks(true, false);
            break;
         case "3":
            handleSearchHomeworks(true, true);
            break;
      }
   }

   const getCardValue = (value) => {
      if (value === null || value === undefined || value === '') {
         return '—';
      }

      return value;
   };

   const getHomeworkScore = (payload) => {
      if (payload.max_score !== null) {
         return payload.score === 0 ? '—' : `${payload.score}/${payload.max_score}`;
      }

      return payload.score === 0 ? '—' : payload.score;
   };

   const getHomeworkStatus = (payload) => {
      if (payload.returned) {
         return { label: 'Returned', className: ' is-warning' };
      }

      if (payload.evaluation_id !== null) {
         return { label: 'Completed', className: ' is-success' };
      }

      if (payload.submit_id !== null) {
         return { label: 'For Evaluation', className: ' is-muted' };
      }

      return { label: 'Not Submitted', className: ' is-danger' };
   };

   const renderCardField = (label, value, { fullWidth = false } = {}) => (
      <div className={`brainee-module-record-field${fullWidth ? ' is-full' : ''}`}>
         <span className="brainee-module-record-label">{label}</span>
         <span className="brainee-module-record-value">{getCardValue(value)}</span>
      </div>
   );

   const renderStudentHomeworkActions = (payload) => (
      <>
         {user_role !== 'Parent'
            ? <Space size="small">
               <Tooltip placement="left" title='Show Homework Details'>
                  <ProfileOutlined color='#4abec7' style={{ cursor: 'pointer' }} onClick={() => handleShowHomeworkDetails(payload.id, (payload.submit_id === null || payload.returned), payload.returned, payload.remarks, payload.plagiarism_checker)} />
               </Tooltip>
               {payload.submit_id !== null && payload.evaluation_id === null &&
                  <Tooltip placement="left" title='Unsubmit Homework'>
                     <Popconfirm
                        title="Are you sure you want to unsubmit your homework?"
                        onConfirm={() => handleRemoveSubmission(payload.submit_id)}
                        okText="Yes"
                        cancelText="No"
                     >
                        <DeleteOutlined color='#4abec7' style={{ cursor: 'pointer' }} />
                     </Popconfirm>
                  </Tooltip>
               }
            </Space>
            : <></>
         }
      </>
   );

   const renderHomeworkCardList = () => (
      <div className="brainee-module-record-list-region">
         <div className="brainee-module-record-list">
            {homeworkList.map((record, index) => {
               const cardKey = record.uid || record.id || `student-homework-card-${index}`;
               const status = getHomeworkStatus(record);

               return (
                  <article className="brainee-module-record-card" key={cardKey}>
                     <div className="brainee-module-record-header">
                        <div className="brainee-module-record-heading">
                           <div className="brainee-module-record-header-row">
                              <span className="brainee-module-record-kicker">{moduleLabel}</span>
                              <span className={`brainee-module-record-pill${status.className}`}>{status.label}</span>
                           </div>
                           <h3>{getCardValue(record.title)}</h3>
                           <p>{getCardValue(record.homework_date)}</p>
                        </div>
                     </div>
                     <div className="brainee-module-record-meta">
                        {renderCardField('Teacher', record.teacher)}
                        {renderCardField(isMicrocredentials ? 'Course' : 'Subject', record.subject, { fullWidth: true })}
                        {renderCardField('Submitted', record.submission_date)}
                        {renderCardField('Evaluated', record.evaluation_date)}
                        {user_role !== 'Parent' ? renderCardField('Score', getHomeworkScore(record)) : null}
                        {renderCardField('Remarks', record.remarks, { fullWidth: true })}
                     </div>
                     <div className="brainee-module-record-actions">
                        {renderStudentHomeworkActions(record)}
                     </div>
                  </article>
               );
            })}
         </div>
         <div className="brainee-module-record-list-footer">Total Records: {homeworkList.length}</div>
      </div>
   );

   const renderTableSkeleton = () => (
      <div className="brainee-module-skeleton-table">
         <div className="brainee-module-skeleton-header">
            <Skeleton.Input active size="small" className="brainee-module-skeleton-title" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-chip" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-chip" />
            <Skeleton.Button active size="small" className="brainee-module-skeleton-action" />
         </div>
         {Array.from({ length: 7 }).map((_, index) => (
            <div className="brainee-module-skeleton-row" key={`student-homework-table-skeleton-${index}`}>
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell is-wide" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Button active size="small" className="brainee-module-skeleton-action" />
            </div>
         ))}
      </div>
   );

   const renderHomeworkTable = () => (
      homeworkListLoading
         ? renderTableSkeleton()
         : homeworkList.length > 0
            ? (
               isCompactListView
                  ? renderHomeworkCardList()
                  : <div className="brainee-module-table-shell">
                     <Table
                        className="brainee-module-table"
                        rowKey={'uid'}
                        size='small'
                        columns={HomeworkListColumns}
                        dataSource={homeworkList}
                        pagination={false}
                        scroll={{
                           x: '1550px',
                           y: 'calc(100svh - 20.5rem)',
                        }}
                        footer={() => <div className="brainee-module-table-footer">Total Records: {homeworkList.length}</div>}
                     />
                  </div>
            )
            : <div className='brainee-module-state'>
               <Empty image="../images/brainee_mascot.png" description={isMicrocredentials ? 'No microcredential homeworks or projects found.' : 'No records found'} />
            </div>
   );

   return (
      <>
         <ProcessingModal
            processing={submitting}
            title={rootLabel}
         />
         <div className="dashboard-area-all brainee-module-page">
            <div className="dashboard-item brainee-module-shell">
               <div className="brainee-module-breadcrumb">
                  {/* <ul>
                     <li><a href="#" onClick={() => navigate('/home')}>Home</a></li>
                     <li><span>/</span></li>
                     <li className="active">Homeworks & Projects</li>
                  </ul> */}
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'lms', node: rootLabel },
                        { key: 'hw', node: <Link to={subjectsRoute}>{moduleLabel}</Link> },
                        { key: 'subject', node: subjectname },
                     ]}
                  />
               </div>

               <section className="brainee-module-hero">
                  <div>
                     <span className="brainee-module-kicker">{heroKicker}</span>
                     <h1>{subjectname || (isMicrocredentials ? 'My Homeworks & Projects' : 'My Homework')}</h1>
                     <p>{isMicrocredentials ? 'Track microcredential homeworks & projects by status and open submissions or returned work by topic.' : 'Track homework by status and open submissions or returned work when you need them.'}</p>
                     <div className="brainee-module-meta">
                        <span><BookOutlined /> {homeworkListLoading ? 'Loading records' : `${homeworkList.length} records`}</span>
                        <span><ClockCircleOutlined /> Not Submitted</span>
                        <span><CheckCircleOutlined /> Submitted</span>
                        <span><RollbackOutlined /> Returned</span>
                     </div>
                  </div>
               </section>

               <section className="brainee-module-panel">
                  <Tabs className="brainee-module-tabs" defaultActiveKey={"1"} centered onChange={(key) => handleTabChange(key)}>
                     <Tabs.TabPane style={{ overflow: isCompactListView ? 'visible' : 'auto' }}
                        tab={(
                           <Tooltip placement="top" title="Not Submitted">
                              <span className="brainee-module-tab-label"><ClockCircleOutlined /> Not Submitted</span>
                           </Tooltip>
                        )}
                        key="1"
                     >
                        {renderHomeworkTable()}
                     </Tabs.TabPane>
                     <Tabs.TabPane style={{ overflow: isCompactListView ? 'visible' : 'auto' }}
                        tab={(
                           <Tooltip placement="top" title="Submitted">
                              <span className="brainee-module-tab-label"><CheckCircleOutlined /> Submitted</span>
                           </Tooltip>
                        )}
                        key="2"
                     >
                        {renderHomeworkTable()}
                     </Tabs.TabPane>
                     <Tabs.TabPane style={{ overflow: isCompactListView ? 'visible' : 'auto' }}
                        tab={(
                           <Tooltip placement="top" title="Returned">
                              <span className="brainee-module-tab-label"><RollbackOutlined /> Returned</span>
                           </Tooltip>
                        )}
                        key="3"
                     >
                        {renderHomeworkTable()}
                     </Tabs.TabPane>
                  </Tabs>
               </section>
            </div>
         </div>

         <Modal
            title={returned ? `${moduleLabel} (Returned)` : moduleLabel}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancelDetails(); }}
            open={detailsModalVisible}
            width='60%'
            className="performance-task-details-modal"
            footer={[
               <Button key="cancel" shape="round" onClick={() => handleCancelDetails()}>
                  Cancel
               </Button>,
               <Button
                  key="submit"
                  type="primary"
                  shape="round"
                  disabled={!canSubmit}
                  loading={submitting}
                  onClick={() => submitFormRef.current?.submitHomework()}
               >
                  Submit
               </Button>
            ]}
         >
            <Details_Submit
               homeworkID={homeworkID}
               onCancelCallback={handleCancelSubmit}
               onSubmitCallback={handleSaveSubmittedHomework}
               canSubmit={canSubmit}
               returned={returned}
               remarks={remarks}
               submitRef={submitFormRef}
            />
         </Modal>

         {/* <Modal
            title={"Homework Details"}
            centered
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            destroyOnClose={true}
            onOk={() => { handleCancelDetails(); }}
            onCancel={() => { handleCancelDetails(); }}
            open={detailsModalVisible}
            // width={window.innerWidth - 900}
            width='70%'
            okButtonProps={{ shape: "round" }}
         >
            <Details
               homeworkID={homeworkID}
            />
         </Modal> */}
      </>
   );
}



